const SWISS_FORMAT_LOCALE = 'de-CH';

export function formatDate(date: string | number | Date): string {
  return new Date(date)
    .toLocaleDateString(SWISS_FORMAT_LOCALE, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    .replaceAll('.', '/');
}

export function formatDateTime(date: string | number | Date): string {
  return new Date(date)
    .toLocaleString(SWISS_FORMAT_LOCALE, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
    .replaceAll('.', '/');
}
